import { render, staticRenderFns } from "./DocumentScaleSelector.vue?vue&type=template&id=d1e47ec8&scoped=true&"
import script from "./DocumentScaleSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentScaleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentScaleSelector.vue?vue&type=style&index=0&id=d1e47ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e47ec8",
  null
  
)

export default component.exports